import { render, staticRenderFns } from "./BookAppointmentButton.vue?vue&type=template&id=40348b53&scoped=true&"
import script from "./BookAppointmentButton.vue?vue&type=script&lang=js&"
export * from "./BookAppointmentButton.vue?vue&type=script&lang=js&"
import style0 from "./BookAppointmentButton.vue?vue&type=style&index=0&id=40348b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40348b53",
  null
  
)

export default component.exports